/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop,Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './stationTree.less';
import { CommonUtil } from 'src/util/commonUtil';
import { Integer, ResultPageDo } from 'src/types/base';
import StationListApi, { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import EnumStationType from 'src/enums/enumStationType';
import StationTreeUtils from './stationTreeUtils';
import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
let bem = createBEM('station-tree');

const StationIcon = {
   [EnumStationType.Water.getId()]: {
    [EnumDeviceStatus.Normal.getId()]: require('src/assets/images/正常01.png'),
    [EnumDeviceStatus.Malfunction.getId()]: require('src/assets/images/报警01.png'),
    [EnumDeviceStatus.Offline.getId()]: require('src/assets/images/离线01.png'),
   },
   [EnumStationType.Pollution.getId()]: {
    [EnumDeviceStatus.Normal.getId()]: require('src/assets/images/正常02.png'),
    [EnumDeviceStatus.Malfunction.getId()]: require('src/assets/images/报警02.png'),
    [EnumDeviceStatus.Offline.getId()]: require('src/assets/images/离线02.png'),
   },
   [EnumStationType.undergroundWater.getId()]: {
    [EnumDeviceStatus.Normal.getId()]: require('src/assets/images/正常01.png'),
    [EnumDeviceStatus.Malfunction.getId()]: require('src/assets/images/报警01.png'),
    [EnumDeviceStatus.Offline.getId()]: require('src/assets/images/离线01.png'),
   },
   [EnumStationType.pipeNetwork.getId()]: {
    [EnumDeviceStatus.Normal.getId()]: require('src/assets/images/正常01.png'),
    [EnumDeviceStatus.Malfunction.getId()]: require('src/assets/images/报警01.png'),
    [EnumDeviceStatus.Offline.getId()]: require('src/assets/images/离线01.png'),
   },
}
export function getStationIcon(station: {type: number, device_status: number}) {
    return StationIcon[station.type][station.device_status]
}

export interface StationTreePropsI {
    value?: string | Integer | string[] | number[];
    stationName?: string;
    showCheckBox?: boolean
    dataSource?: any[]
}

@Component
export default class StationTree extends Vue.Component<StationTreePropsI> {
    @Prop({
        type: [String, Number, Array],
    })
    value!: string | number;

    @Prop({
        type: String,
        default: ''
    })
    stationName!: string;

    @Prop({
        type: Boolean,
    })
    showCheckBox!: boolean;

    @Prop({
        type: Array,
    })
    dataSource!: any[];

    data:any = [];
    getStationPromise!:Promise<ResultPageDo<StationListDOI.RowDataI[]>> 
    originData:ReadonlyArray<StationListDOI.RowDataI>= [];
    clickNode(node) {
        if (CommonUtil.isUndefined(node.node.children) && !this.showCheckBox) {
            console.log('node.node.mn', node.node.mn);
            this.$emit('input', node.node.mn);
            this.$emit('click', node.node);
        }
    }

    @Watch('stationName')
    stationNameChange() {

        this.setTreeData(this.originData.filter(i=> ~i.name.indexOf(this.stationName)))
    }

    async getStationDetailByMN(mn: string):Promise<StationListDOI.RowDataI> {
        let data = await this.getStationPromise
        return data.data.data_info.find(i=> i.mn === mn) as StationListDOI.RowDataI
    }

    async getStations():Promise<StationListDOI.RowDataI[]> {
        let data = await this.getStationPromise
        return data.data.data_info

    }

    // 用户多选
    clearCheckedNode() {
        CommonUtil.treeForEach<any>(this.data, (item)=> {
            delete item.checked 
            delete item.indeterminate
        })
        this.data = [...this.data]
    }
    renderContent(h, { root, node, data }) {
        EnumStationType
        return (
            <div
                class={bem('node', {
                    pointer: CommonUtil.isUndefined(node.node.children),
                    selected: node.node.mn === this.value && !CommonUtil.isUndefined(this.value) && !this.showCheckBox,
                })}
                onClick={this.clickNode.bind(this, node)}
            >
                <img width="13px" v-if={CommonUtil.isUndefined(node.node.children)} src={getStationIcon(node.node)}/>
                <i v-else-if={node.node.title==='中国'} class="icon-zhongguoditu wqms-font" style="color:#d70100;vertical-align: middle;font-size:18px" />
                <i v-else-if={node.node.expand} class="icon-wenjianjiakai wqms-font" style="color:#1DA4FF" />
                <i v-else  class="icon-wenjianjiaguan wqms-font" style="color:#EFFB29"/>
                <span class="wqms-ml5">{CommonUtil.isUndefined(node.node.children)?node.node.name:node.node.title}</span>
            </div>
        );
    }
    async getTreeData() {
        this.getStationPromise = StationListApi.searchDeviceList({page_index: 1, page_size: 1000000, device_name: this.stationName, type: EnumStationType.findCode(this.$route.params.type).getId()})
        let {code, data} = await this.getStationPromise;
        if(code === 0) {
            if(data.data_info.length === 0) {
                this.data = []
            }
            // this.data = this.groupBy(data.data_info, 'province_name', 'province_id', !!this.stationName)
            // this.data.forEach(element => {
            //     element.children = this.groupBy(element.children, 'city_name', 'city_id',!!this.stationName)
            // });
            // this.data.forEach(element => {
            //     element.children.forEach(i=> {
            //         i.children = this.groupBy(i.children, 'district_name', 'district_id',!!this.stationName)
            //     })
            // }); 
            this.originData = Object.freeze(data.data_info);
            this.setTreeData(data.data_info)
        }
    }

    setTreeData(data_info:StationListDOI.RowDataI[]) {
        this.data = StationTreeUtils.getAreaStationTree(data_info, !!this.stationName,!!this.stationName,!!this.stationName)
        setTimeout(()=> {
         this.openNodeByMn(this.value as any)
        })
    }


    async openNodeByMn(mn: string) {
        if(!mn) {
            return
        }
        let data = await this.getStationDetailByMN(mn)
        let province = this.data[0].children.find(i=> i.title === data.province_name)
        province.expand = true
        let city = province.children.find(i=> i.title === data.city_name)
        city.expand = true
        let district = city.children.find(i=> i.title === data.district_name)
        district.expand = true
    }
    groupBy(data:StationListDOI.RowDataI[], nameField: string, idField: string,expand=false){
        if(!data[0][nameField]) {
            return data
        }
        let map: {[str: string]: StationListDOI.RowDataI[]} = {}
        data.forEach(element => {
            map[element[nameField]]= map[element[nameField]]||[]
            map[element[nameField]].push(element)
        });
        return Object.values(map).map(i=> ({
            title: i[0][nameField],
            id: i[0][idField],
            children: i,
            expand
        }))
    }
    checkChange(nodes) {
        let stations:StationListDOI.RowDataI[] = nodes.filter(i=> !i.children)
        this.$emit('check-change', stations.map(i=>i.mn), stations)
    }

    mounted() {
        if(!this.dataSource) {
            this.getTreeData()
        }
    }
    render(h) {
        return <tree ref="tree" class={bem()} data={this.dataSource?this.dataSource:this.data} render={this.renderContent} show-checkbox={this.showCheckBox} on-on-check-change={this.checkChange.bind(this)}/>;
    }
}
